var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _circle, _circle2, _path, _path2, _path3, _path4, _path5, _rect7, _path6, _rect8, _path7, _path8, _path9, _path10, _path11, _rect9, _rect10, _rect11, _path12, _circle3, _path13, _path14;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWinkRobot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 148,
    viewBox: "0 0 354 472",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 10,
    width: 279,
    height: 219,
    rx: 34,
    fill: "#FDFFF4",
    stroke: "#280003",
    strokeWidth: 20
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 22,
    width: 249,
    height: 195,
    rx: 34,
    fill: "#C5D0D4",
    stroke: "#FDFBEC",
    strokeWidth: 20
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 47,
    width: 201,
    height: 144,
    rx: 44,
    fill: "#FDFFF2"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 10,
    width: 279,
    height: 219,
    rx: 34,
    fill: "#FDFFF4",
    stroke: "#280003",
    strokeWidth: 20
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 22,
    width: 249,
    height: 195,
    rx: 34,
    fill: "#C5D0D4",
    stroke: "#FDFBEC",
    strokeWidth: 20
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 47,
    width: 201,
    height: 144,
    rx: 44,
    fill: "#FDFFF2"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 126,
    cy: 101,
    r: 19,
    fill: "#280003"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 219,
    cy: 101,
    r: 19,
    fill: "#280003"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M219 152.5C219 154.68 217.77 156.837 215.381 158.849C212.992 160.861 209.492 162.686 205.082 164.221C200.671 165.755 195.439 166.967 189.687 167.787C183.936 168.607 177.778 169.019 171.57 168.999C165.362 168.979 159.226 168.528 153.518 167.671C147.81 166.814 142.642 165.568 138.313 164.006C133.983 162.444 130.579 160.596 128.295 158.569C126.011 156.542 124.894 154.377 125.008 152.198L144.993 152.326C144.928 153.579 145.57 154.823 146.882 155.988C148.195 157.153 150.151 158.215 152.639 159.113C155.128 160.01 158.098 160.726 161.378 161.219C164.659 161.711 168.185 161.971 171.753 161.982C175.321 161.994 178.859 161.757 182.165 161.286C185.471 160.814 188.478 160.118 191.012 159.236C193.547 158.354 195.559 157.305 196.932 156.149C198.305 154.993 199.011 153.753 199.011 152.5H219Z",
    fill: "#280003"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65 237H288V381C288 389.284 281.284 396 273 396H80C71.7157 396 65 389.284 65 381V237Z",
    fill: "#280003"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M86.5 254.5H266.5V371C266.5 375.142 263.142 378.5 259 378.5H94C89.8579 378.5 86.5 375.142 86.5 371V254.5Z",
    fill: "#C2D1D4",
    stroke: "#FFFEF2",
    strokeWidth: 15
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M324 81H334C342.284 81 349 87.7157 349 96V152C349 160.284 342.284 167 334 167H324V81Z",
    fill: "#FCBD00",
    stroke: "#240002",
    strokeWidth: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M30 162V76H20C11.7157 76 5 82.7157 5 91V147C5 155.284 11.7157 162 20 162H30Z",
    fill: "#FCBD00",
    stroke: "#240002",
    strokeWidth: 10
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 93,
    y: 395,
    width: 73,
    height: 39,
    fill: "#1388D8",
    stroke: "#240002",
    strokeWidth: 12
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M168 437V433H164H100C86.7452 433 76 443.745 76 457V464V468H80H164H168V464V437Z",
    fill: "#FE5E67",
    stroke: "#240002",
    strokeWidth: 8
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: -6,
    width: 73,
    height: 39,
    transform: "matrix(-1 0 0 1 267 401)",
    fill: "#1388D8",
    stroke: "#240002",
    strokeWidth: 12
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M186 437V433H190H254C267.255 433 278 443.745 278 457V464V468H274H190H186V464V437Z",
    fill: "#FE5E67",
    stroke: "#240002",
    strokeWidth: 8
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M65 318H69V314V259H65V255C37.938 255 16 276.938 16 304V314V318H20H65Z",
    fill: "#BFCED1",
    stroke: "#280003",
    strokeWidth: 8
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M65 319H69V323V340.5C69 355.136 57.1355 367 42.5 367C27.8645 367 16 355.136 16 340.5V323V319H20H65Z",
    fill: "#FFB901",
    stroke: "#280003",
    strokeWidth: 8
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M285 318H281V314V259H285V255C312.062 255 334 276.938 334 304V314V318H330H285Z",
    fill: "#BFCED1",
    stroke: "#280003",
    strokeWidth: 8
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M285 319H281V323V340.5C281 355.136 292.864 367 307.5 367C322.136 367 334 355.136 334 340.5V323V319H330H285Z",
    fill: "#FFB901",
    stroke: "#280003",
    strokeWidth: 8
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 37,
    y: 15.6978,
    width: 279,
    height: 219,
    rx: 34,
    fill: "#FDFFF4",
    stroke: "#280003",
    strokeWidth: 20
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 52,
    y: 27.6978,
    width: 249,
    height: 195,
    rx: 34,
    fill: "#C5D0D4",
    stroke: "#FDFBEC",
    strokeWidth: 20
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 76,
    y: 52.6978,
    width: 201,
    height: 144,
    rx: 44,
    fill: "#FDFFF2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M219 158.198C219 160.377 217.77 162.535 215.381 164.547C212.992 166.559 209.492 168.384 205.082 169.918C200.671 171.452 195.439 172.665 189.687 173.485C183.936 174.305 177.778 174.717 171.57 174.697C165.362 174.677 159.226 174.226 153.518 173.368C147.81 172.511 142.642 171.266 138.313 169.704C133.983 168.141 130.579 166.294 128.295 164.267C126.011 162.24 124.894 160.075 125.008 157.896L144.993 158.024C144.928 159.276 145.57 160.521 146.882 161.686C148.195 162.851 150.151 163.913 152.639 164.81C155.128 165.708 158.098 166.424 161.378 166.917C164.659 167.409 168.185 167.669 171.753 167.68C175.321 167.692 178.859 167.455 182.165 166.983C185.471 166.512 188.478 165.815 191.012 164.934C193.547 164.052 195.559 163.003 196.932 161.847C198.305 160.691 199.011 159.45 199.011 158.198H219Z",
    fill: "#280003"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 212,
    cy: 108.698,
    r: 19,
    fill: "#280003"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M106.44 119.558C105 118.269 104.878 116.056 106.168 114.616L121.513 97.4828C122.802 96.0429 125.015 95.921 126.455 97.2106V97.2106C127.895 98.5002 128.017 100.713 126.727 102.153L111.382 119.286C110.093 120.726 107.88 120.848 106.44 119.558V119.558Z",
    fill: "#280003"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M142.622 119.38C144.062 118.091 144.184 115.878 142.894 114.438L127.549 97.305C126.26 95.8651 124.047 95.7433 122.607 97.0329V97.0329C121.167 98.3225 121.045 100.535 122.335 101.975L137.68 119.108C138.969 120.548 141.182 120.67 142.622 119.38V119.38Z",
    fill: "#280003"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWinkRobot);
export default __webpack_public_path__ + "static/media/WinkRobot.e0a1d7b122cc76b43d76a50d1b4f65cb.svg";
export { ForwardRef as ReactComponent };